import PropTypes from 'prop-types'
import { colors } from '@lmc/common/constants'
import { ButtonOLD, EmptyState, NoDataIcon } from '@lmc/ui-kit'
import { EmptyStateDescription } from '@lmc/ui-kit/src/dataDisplay/EmptyState'

const renderNotOnboarded = (props) => {
  const { openOnboardingModal } = props
  const helpLink =
    'https://support.logmycare.co.uk/en/articles/4851795-how-do-i-add-a-medication'

  //do we change this screen as well?

  return (
    <div style={styles.emptyStateWrapper}>
      <div
        style={{
          ...styles.emptyStateImagesContainer,
          justifyContent: 'center',
        }}
      >
        <img
          alt=""
          src={
            'https://lmc-data-production.s3.eu-west-2.amazonaws.com/icons/emar/emarheadericon.png'
          }
          style={{ margin: '0px 0px 16px', maxHeight: 100 }}
        />
      </div>
      <h2 style={styles.emptyStateTitle}>eMAR Module</h2>
      <div style={styles.emptyStateText}>
        <div>
          eMAR is a powerful electronic medication administration and recording
          tool that reduces the amount of time spent managing your service
          users’ medication needs. eMAR lets care Managers easily organise their
          service users’ medication records digitally, safeguarding against
          illegible notes and missed signatures and making medication rounds a
          breeze.
        </div>
        <div>
          <a href={helpLink} target="_blank" rel="noreferrer">
            Learn more here
          </a>
        </div>
      </div>
      <ButtonOLD
        id="open-emar-onboarding"
        onClick={() => openOnboardingModal()}
        style={{ marginBottom: 16 }}
        type="primary"
      >
        Set Up eMAR
      </ButtonOLD>
      <div
        style={{
          fontSize: 12,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginBottom: 16,
        }}
      >
        <div>You will be setting up:</div>
        <div>• Medication times and cycles for your care service</div>
        <div>• Which team members can sign medication</div>
      </div>
    </div>
  )
}

export default function EMARScreenEmptyState(props) {
  const {
    displayArrow = true,
    emarOnboarded,
    resident: { name, preferredName },
  } = props

  if (!emarOnboarded) return renderNotOnboarded(props)

  const helpLink =
    'https://support.logmycare.co.uk/en/articles/4851795-how-do-i-add-a-medication'

  const labelStyle = {
    ...styles.emptyStateArrowLabel,
    visibility: displayArrow ? 'visible' : 'hidden',
  }

  return (
    <div style={styles.emptyStateWrapper}>
      <EmptyState
        icon={<NoDataIcon />}
        title={`${preferredName || name.first} has no medications yet`}
        description={
          <EmptyStateDescription>
            Learn more about adding a medication{' '}
            <a href={helpLink} target="_blank" rel="noreferrer">
              here
            </a>.
          </EmptyStateDescription>
        }
      />
    </div>
  )
}

EMARScreenEmptyState.propTypes = {
  displayArrow: PropTypes.bool,
  emarOnboarded: PropTypes.bool,
  openOnboardingModal: PropTypes.func,
  resident: PropTypes.object.isRequired,
}

const styles = {
  emptyStateArrowLabel: {
    marginRight: 35,
    maxWidth: 135,
  },
  emptyStateDino: {
    margin: '25px 0px 30px',
    maxHeight: 165,
  },
  emptyStateImagesContainer: {
    alignItems: 'flex-start',
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 12,
    width: '100%',
  },
  emptyStateText: {
    lineHeight: '22px',
    maxWidth: 700,
    marginBottom: 35,
    textAlign: 'center',
  },
  emptyStateTitle: {
    lineHeight: '36px',
  },
  emptyStateWrapper: {
    alignItems: 'center',
    background: colors.white,
    borderRadius: 15,
    display: 'flex',
    flexDirection: 'column',
    marginTop: 20,
    width: '100%',
    padding: 22,
  },
}
